import { useRef, useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onSave, saving, savedUrl }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1B3A5B";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const cx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
    const cy = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
    return { x: cx, y: cy };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const draw = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke(); setHasInk(true); };
  const stop = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setHasInk(false); };

  const save = () => {
    const c = canvasRef.current;
    c.toBlob((blob) => onSave(blob), "image/png");
  };

  return (
    <div>
      {savedUrl ? (
        <div className="rounded-lg border border-emerald-300 bg-emerald-50 p-3 text-center text-sm font-medium text-emerald-700" data-testid="signature-saved">✓ Firmato</div>
      ) : (
        <>
          <canvas ref={canvasRef} width={440} height={150} data-testid="signature-canvas"
            className="w-full touch-none rounded-lg border-2 border-dashed border-slate-300 bg-white"
            onMouseDown={start} onMouseMove={draw} onMouseUp={stop} onMouseLeave={stop}
            onTouchStart={start} onTouchMove={draw} onTouchEnd={stop} />
          <div className="mt-2 flex gap-2">
            <Button type="button" variant="outline" size="sm" className="gap-1" onClick={clear}><Eraser size={14} /> Cancella</Button>
            <Button type="button" data-testid="save-signature-btn" size="sm" disabled={!hasInk || saving} onClick={save} className="bg-primary hover:bg-primary/90">
              {saving ? "..." : "Conferma firma"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
